module.exports = __webpack_public_path__ + "static/media/Score-Med.864c0138.svg";